module.exports = __webpack_public_path__ + "img/waiter.73d3482e.png";